import React from "react";
import PropTypes from "prop-types";
import { Modal, Button, Space } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const ConfirmarDesasignacionDialog = ({
  open,
  onClose,
  onConfirm,
  vehiculo,
  conductor,
}) => {
  return (
    <Modal
      title="Confirmar Desasignación"
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancelar
        </Button>,
        <Button
          key="confirm"
          type="primary"
          danger
          onClick={onConfirm}
        >
          Desasignar
        </Button>,
      ]}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <div>
          <ExclamationCircleOutlined style={{ color: "#faad14", marginRight: 8 }} />
          ¿Está seguro que desea desasignar el conductor?
        </div>
        <div>
          <strong>Vehículo:</strong> {vehiculo?.placa} - {vehiculo?.codigo}
        </div>
        <div>
          <strong>Conductor:</strong> {conductor?.nombre} - {conductor?.numero_documento}
        </div>
      </Space>
    </Modal>
  );
};

ConfirmarDesasignacionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  vehiculo: PropTypes.shape({
    placa: PropTypes.string,
    codigo: PropTypes.string,
  }),
  conductor: PropTypes.shape({
    nombre: PropTypes.string,
    numero_documento: PropTypes.string,
  }),
};

export default ConfirmarDesasignacionDialog; 